<template>
  <header>
    <div class="top-bar" :class="{ 'active': topbarActive }">
      <div class="container">
        <span>Join our discord community to chat with the team.</span>
        <a href="https://discord.gg/7M84Xp8QBr" target="_blank" class="btn-style top-btn">Discord</a>
        <a href="#" class="top-bar-close-icon" @click="topbarCloseBtn">
          <img src="../assets/images/icon/top-bar-close-icon.svg" alt="top-bar-close-icon">
        </a>
      </div>
    </div>

    <div class="header" :class="{ 'active': activeIndex }">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-lg-3 align-self-center">
            <div class="logo-wrapper">
              <RouterLink to="/" class="logo logocloud">
                <img class="logocloud" src="../assets/images/icon/logo-icon.svg" alt="logo-icon">
              </RouterLink>
              <a href="#" id="hamburger" @click="addMenuClass" :class="{ 'active': isMenuActive }">
                <img src="../assets/images/icon/hamburger-mobile-icon.svg" alt="hamburger-mobile-icon">
              </a>
            </div>
          </div>

          <div class="col-md-6 align-self-center">
            <div class="menu-wrapper" :class="{ 'active': isMenuActive }">
              <a href="#" id="cross-btn" @click="closeMenu()">
                <img src="../assets/images/icon/cross-mobile-icon.svg" alt="cross-mobile-icon">
              </a>
              <ul class="menu">
                <li class="dropdown" @click="handleLiClick(1)">
                  <a href="#">Products</a>
                  <div class="dropdown-menu" :class="{ 'active': activeIndex === 1 }">
                    <div class="container ex-large">
                      <a href="#" class="dropdown-close">
                        <img src="../assets/images/icon/dropdown-close-icon.svg" alt="dropdown-close-icon">
                      </a>
                      <div class="row">
                        <div class="col-md-4">
                          <div class="main-img-wrapper">
                            <div class="img-wrapper">
                              <img src="../assets/images/console.png" alt="blog-img-1">
                            </div>
                            <div class="content-wrapper">
                              <a href="https://console.cloudblast.io/">
                                <p>Try our new console</p>
                                <img src="../assets/images/icon/dropdowm-right-arrow.svg" alt="dropdowm-right-arrow" class="right-arrow">
                              </a>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-8">
                          <div class="right-content-wrapper">
                            <div class="heading">
                              <h3>Discover our wide range of services
                                <img src="../assets/images/icon/arrow-forward-icon.svg" alt="arrow-forward-icon">
                              </h3>
                              <span>Welcome! Begin your experience with our amazing cloud.</span>
                            </div>
                            <div class="row">
                              <div class="col-md-4">
                                <RouterLink to="/pricing">
                                  <div class="main-dropdown-menu-wrapper">
                                    <strong>Cloud Servers (VPS)</strong>
                                    <p>Explore our affordable plans tailored for diverse customer needs and budgets.</p>
                                  </div>
                                </RouterLink>
                              </div>
                              <div class="col-md-4">
                                <RouterLink to="/blog/1">
                                  <div class="main-dropdown-menu-wrapper">
                                    <strong>Blog</strong>
                                    <p>Dive into engaging articles, latest updates, and industry insights here.</p>
                                  </div>
                                </RouterLink>
                              </div>
                              <div class="col-md-4">
                                <RouterLink to="/api">
                                  <div class="main-dropdown-menu-wrapper">
                                    <strong>API's</strong>
                                    <p>Find here our latest API endpoints documentation.</p>
                                  </div>
                                </RouterLink>
                              </div>
                              <div class="col-md-4">
                                <a href="https://cloudblast.canny.io/" target="_blank">
                                  <div class="main-dropdown-menu-wrapper">
                                    <strong>Roadmap</strong>
                                    <p>Discover our future plans and exciting features in development now.</p>
                                  </div>
                                </a>
                              </div>
                              <div class="col-md-4">
                                <RouterLink to="/help">
                                  <div class="main-dropdown-menu-wrapper">
                                    <strong>Help Center</strong>
                                    <p>Get assistance, FAQs, and resources for troubleshooting and user support.</p>
                                  </div>
                                </RouterLink>
                              </div>
                              <div class="col-md-4">
                                <RouterLink to="/contact">
                                  <div class="main-dropdown-menu-wrapper">
                                    <strong>Contact Us</strong>
                                    <p>Reach out for inquiries, support, or feedback; we're here to help.</p>
                                  </div>
                                </RouterLink>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <li class="dropdown" @click="handleLiClick(2)">
                  <a href="#">Solutions</a>
                  <div class="dropdown-menu" :class="{ 'active': activeIndex === 2 }">
                    <div class="container">
                      <div class="row">
                        <div class="col-md-3">
                          <RouterLink to="/article/Gaming-Solutions">
                            <div class="main-dropdown-menu-wrapper">
                              <strong>Gaming</strong>
                              <p>Low latency, ddos protected game servers, perfect for your community.</p>
                            </div>
                          </RouterLink>
                        </div>
                        <div class="col-md-3">
                          <RouterLink to="/article/Elevate-Your-Trading-to-the-Next-Level-with-CloudBlast">
                            <div class="main-dropdown-menu-wrapper">
                              <strong>Trading & Forex</strong>
                              <p>Extremely fast, low latency solutions for trading bots.</p>
                            </div>
                          </RouterLink>
                        </div>
                        <div class="col-md-3">
                          <RouterLink to="/article/Retail-and-E-Commerce-Solutions">
                            <div class="main-dropdown-menu-wrapper">
                              <strong>Retail and E-Commerce</strong>
                              <p>Fast and reliable solutions for retails and e-commerces stores.</p>
                            </div>
                          </RouterLink>
                        </div>
                        <div class="col-md-3">
                          <RouterLink to="/article/Streaming-&-Media-Solutions">
                            <div class="main-dropdown-menu-wrapper">
                              <strong>Streaming & Media</strong>
                              <p>Scalable solutions for streaming services and media outlets</p>
                            </div>
                          </RouterLink>
                        </div>
                        <div class="col-md-3">
                          <RouterLink to="/affiliate">
                            <div class="main-dropdown-menu-wrapper">
                              <strong>Affiliate</strong>
                              <p>Start earning a passive income with your affiliate link.</p>
                            </div>
                          </RouterLink>
                        </div>
                        <div class="col-md-3">
                          <RouterLink to="/whitelabel">
                            <div class="main-dropdown-menu-wrapper">
                              <strong>Whitelabel Cloud</strong>
                              <p>Start your own cloud business in few clicks and with no technical knowledge.</p>
                            </div>
                          </RouterLink>
                        </div>
                        <div class="col-md-3">
                          <RouterLink to="/contact">
                            <div class="main-dropdown-menu-wrapper">
                              <strong>Contact Us</strong>
                              <p>Reach out for inquiries, support, or feedback; we're here to help.</p>
                            </div>
                          </RouterLink>
                        </div>
                        <div class="col-md-3">
                          <RouterLink to="/about">
                            <div class="main-dropdown-menu-wrapper">
                              <strong>About Us</strong>
                              <p>Discover more about us, our datacenters and partners.</p>
                            </div>
                          </RouterLink>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <li><RouterLink to="/pricing" class="menueffect">Pricing</RouterLink></li>
                <li><RouterLink to="/blog/1" class="menueffect">Blog</RouterLink></li>
                <li><RouterLink to="/about" class="menueffect">About Us</RouterLink></li>
              </ul>
            </div>
          </div>

          <div class="col-md-3 align-self-center">
            <div class="contact-btn-wrapper">
              <a href="https://console.cloudblast.io/">
                <img src="../assets/images/icon/headere-contact-btn-icon.png" alt="headere-contact-btn-icon">
              </a>
              <a href="https://console.cloudblast.io/" class="btn-style transparent material-bubble btn-arrow">
                <span style="font-weight:500;font-size:18px;color:#fff;">Console
                  <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.00002 0.710632C0.61002 1.10063 0.61002 1.73063 1.00002 2.12063L4.88002 6.00063L1.00002 9.88063C0.61002 10.2706 0.61002 10.9006 1.00002 11.2906C1.39002 11.6806 2.02002 11.6806 2.41002 11.2906L7.00002 6.70063C7.39002 6.31063 7.39002 5.68063 7.00002 5.29063L2.41002 0.700632C2.03002 0.320632 1.39002 0.320632 1.00002 0.710632Z" fill="white" />
                  </svg>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
  <PromotionalPopup />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import PromotionalPopup from './PromotionalPopup.vue';

export default defineComponent({
  name: 'HeaderComponent',
  components: {
    PromotionalPopup
  },
  props: {
    msg: String,
  },
  data() {
    return {
      isMenuActive: false,
      productMenu: false,
      solutionMenu: false,
      topbarActive: false,
      activeIndex: null as null | number,
    };
  },
  methods: {
    addMenuClass() {
      this.isMenuActive = true;
    },
    closeMenu() {
      this.isMenuActive = false;
    },
    topbarCloseBtn() {
      this.topbarActive = true; // Toggle the state on each click
    },
    handleLiClick(index: number) {
      if (this.activeIndex === index) {
        // Clicking on the same li, so toggle the active state
        this.activeIndex = null;
      } else {
        // Clicking on a different li, set the activeIndex to the new index
        this.activeIndex = index;
      }
    },
    setCookie(name: string, value: string, days: number) {
      let expires = "";
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/; domain=.cloudblast.io";
    },
    checkAndSetReferralCookie() {
      const urlParams = new URLSearchParams(window.location.search);
      const ref = urlParams.get('ref');
      if (ref) {
        this.setCookie('cloudblast_ref', ref, 7); // Set for 7 days
      }
    }
  },
  mounted() {
    this.checkAndSetReferralCookie();
  }
});
</script>
